import { useTranslation } from 'next-i18next';
import { FC } from 'react';

interface ReadingTimeProps {
  minutes: string;
  separator: boolean;
}

export const ReadingTime: FC<ReadingTimeProps> = ({
  minutes,
  separator = false,
}) => {
  const { t } = useTranslation('common');

  if (!minutes.trim()) {
    return null;
  }

  return (
    <>
      {separator && (
        <span aria-hidden="true" className="mx-1 before:content-['·']" />
      )}
      <span>{t('readingTime', { minutes })}</span>
    </>
  );
};
